// https://masonry.desandro.com/
main.masonry = (function () {
    var infiniteGrid = document.querySelector('.js-infinite-grid');

    var init = function () {
        if (infiniteGrid != null) { 
            _initPagination(infiniteGrid);
            infiniteGrid.classList.remove('u-hidden-transition');
        }
    };

    function _getPenPath() {
        // console.log("_getPanPath", this.loadCount);
        var pageNumber = ( this.loadCount + 1);
        var newPageNumber = '/page/' + pageNumber;
        return newPageNumber;
    }

    var _initPagination = function (grid) {
        var msnry = new Masonry( grid, {
            itemSelector: 'none', // select none at first
            columnWidth: '.grid__col-sizer',
            gutter: '.grid__gutter-sizer',
            percentPosition: true,
            stagger: 30,
            horizontalOrder: true,
            // nicer reveal transition
            visibleStyle: { transform: 'translateY(0)', opacity: 1 },
            hiddenStyle: { transform: 'translateY(40px)', opacity: 0 },
        });


        // initial items reveal
        imagesLoaded( grid, function() {
            grid.classList.remove('are-images-unloaded');
            msnry.options.itemSelector = '.c-grid__item';
            var items = grid.querySelectorAll('.c-grid__item');
            msnry.appended( items );
        });

        var totalPages = grid.dataset.totalPages;
        var baseUrl = grid.dataset.currentBaseurl.replace(/\/$/, "");
        var pages = [];
        for (var i = 2; i <= totalPages; i++) {
            pages.push(i);
        }
  
        function getPenPath() {
            var slug = pages[ this.loadCount ];
            if (slug == undefined) {
                slug = 1;
            }
            var path = baseUrl + '/page/' + slug;
            // console.log(path)
            return path;
        }

        //-------------------------------------//
        // init Infinte Scroll
        if (document.querySelector('.page-load-status')) {
            var infScroll = new InfiniteScroll( grid, {
                history: 'replace',
                historyTitle: true,
                path: getPenPath,
                append: '.c-grid__item',
                outlayer: msnry,
                status: '.page-load-status',
                scrollThreshold: false,
                button: '.js-link-next',
            }); 
        } else {
            var infScroll = new InfiniteScroll( grid, {
                history: 'replace',
                historyTitle: true,
                path: getPenPath,
                append: '.c-grid__item',
                outlayer: msnry,
                scrollThreshold: false
            });
        }
       
        infScroll.on( 'append', function( response, path, items ) {
            setTimeout(function() {
                // console.log( 'trigger msnry layout' ); // trigger rerender layout
                msnry.layout();
            }, 100);
            if (pages.length + 1 == infScroll.pageIndex) {
                var btn = document.querySelector('.js-link-next');
                main.utils.addClass(btn, 'u-hidden');
            }
        });

        // add event listener for initial layout
        // msnry.on( 'layoutComplete', function( items ) {
        //   console.log( 'msnry layoutComplete' );
        // });
    };

    return {
        init: init
    };

})();
